export default {
      id: "ic-kuponlarim-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-kuponlarim-usage",
      toString: function () {
        return this.url;
      }
    }